// Failed route request → the Result step's error state (kind, copy, footer action).

const DEFAULT_MESSAGES = {
  NO_VALID_ROUTE:
    "No valid route found. Please check RNW Analyser and voyage specifications.",
  NETWORK: "Service is unreachable. Please try again later.",
  SERVER: "Please try again later.",
  INVALID_REQUEST: "Please check voyage specifications!",
}

const endpointMessage = (target) =>
  `${target === "arrival" ? "Arrival" : "Departure"} position is too far from the route network. Move it closer to navigable water or a port.`

export function routeErrorFromFailure({ code, detail, attemptedAt = null }) {
  const base = { target: null, attemptedAt }
  if (code === 422 && detail?.error === "ENDPOINT_UNREACHABLE") {
    const target = detail.target === "arrival" ? "arrival" : "departure"
    return {
      ...base,
      kind: "ENDPOINT_UNREACHABLE",
      target,
      message: detail.message || endpointMessage(target),
    }
  }
  if (code === 422 && detail?.error === "NO_VALID_ROUTE") {
    return {
      ...base,
      kind: "NO_VALID_ROUTE",
      message: detail.message || DEFAULT_MESSAGES.NO_VALID_ROUTE,
    }
  }
  if (!code) return { ...base, kind: "NETWORK", message: DEFAULT_MESSAGES.NETWORK }
  if (code >= 500) return { ...base, kind: "SERVER", message: DEFAULT_MESSAGES.SERVER }
  if (code >= 400) {
    return { ...base, kind: "INVALID_REQUEST", message: DEFAULT_MESSAGES.INVALID_REQUEST }
  }
  return null
}

// Request error (status + JSON body snippet) → routeErrorFromFailure.
export function routeErrorFromRequestError(error, attemptedAt = null) {
  let server = null
  try {
    server = error?.bodySnippet ? JSON.parse(error.bodySnippet) : null
  } catch {
    server = null
  }
  return routeErrorFromFailure({
    code: error?.status || error?.code,
    detail: server?.detail,
    attemptedAt,
  })
}

export function routeErrorChipLabel(routeError) {
  switch (routeError?.kind) {
    case "ENDPOINT_UNREACHABLE":
      return routeError.target === "arrival"
        ? "Arrival position unreachable"
        : "Departure position unreachable"
    case "NO_VALID_ROUTE":
      return "No valid route"
    case "NETWORK":
      return "Service unreachable"
    case "SERVER":
      return "Server error"
    default:
      return "Invalid request"
  }
}

// Wizard step to adjust inputs in, or null when the same request is retried.
export function routeErrorAdjustStep(kind) {
  if (kind === "ENDPOINT_UNREACHABLE") return 0
  if (kind === "NETWORK" || kind === "SERVER") return null
  return 1
}
